import { useState } from 'react'
import { isIOSOrSafari } from '@revbox/helpers-fe'

export async function notifyUser(
    notificationText = 'Thank you for enabling notifications!',
    options = {
        body: 'Now you will receive notifications from Revbox',
        icon: 'https://revbox-email-icons.s3.eu-central-1.amazonaws.com/logo_icon-white.png',
        dir: 'ltr'
    }
) {
    if (!('Notification' in window)) {
        alert('Browser does not support notifications')
        return
    }

    if (Notification.permission === 'granted') {
        const notification = new Notification(notificationText, options)
        notification.onclick = function () {
            window.open('https://github.com/revbox/revbox-hub/tree/develop')
        }
        return
    }

    if (Notification.permission !== 'denied') {
        const permission = await Notification.requestPermission()
        if (permission === 'granted') {
            new Notification(notificationText, options)
        }
    }
}

export function useNotifications() {
    const [userResponded, setUserResponded] = useState(false)

    const setupNotifications = async () => {
        if (isIOSOrSafari()) {
            console.log('Not running notifyUser since the browser is Safari or iOS.')
            return
        }
        if (userResponded && Notification.permission === 'granted') {
            return
        }

        notifyUser().then(() => {
            setUserResponded(true)
        })

    }

    return { setupNotifications }
}
